import { withAuthenticationRequired } from "@auth0/auth0-react";

export default function ProtectedRoute({ children }) {
  const Inner = () => <>{children}</>;

  const Guarded = withAuthenticationRequired(Inner, {
    onRedirecting: () => <div style={{ padding: 24 }}></div>, //usunac elemeny css
  });

  return <Guarded />;
}

